import '.bf{position:relative;}.ssr-plugin'
import '.iw{width:64px;}.ssr-plugin'
import '.ix{height:64px;}.ssr-plugin'
import '.av{flex-shrink:0;}.ssr-plugin'
import '.by{position:absolute;}.ssr-plugin'
import '.iy{bottom:-4px;}.ssr-plugin'
import '.fp{right:-4px;}.ssr-plugin'
import '.ey{border-radius:50%;}.ssr-plugin'
import '.iz{border:2px solid var(--palette-white);}.ssr-plugin'
import '.a1{overflow:hidden;}.ssr-plugin'
import '.j0{width:32px;}.ssr-plugin'
import '.j1{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bf iw ix av"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="by iy fp ey iz a1 j0 j1"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
